import { BoundSelectField, BoundSelectFieldProps } from "@homebound/beam";
import { FieldState } from "@homebound/form-state";
import { ReactNode } from "react";
import { Stage } from "src/generated/graphqlTypes";
import { isContractualStage } from "src/utils/projects";

// Minimal project stage shape the "Related Contract" select needs. Each call site pulls
// project stages from a different GraphQL fragment, so we type this structurally rather
// than tying it to one fragment.
type RelatedContractStage = { id: string; hasSignedContract: boolean; stage: { name: string; code: Stage } };

type RelatedContractBoundSelectFieldProps = Pick<BoundSelectFieldProps<RelatedContractStage, string>, "readOnly"> & {
  field: FieldState<any>;
  projectStages: RelatedContractStage[];
  // Defaults to the standard hint. Pass `undefined` to hide it (e.g. read-only views).
  helperText?: ReactNode;
};

/** Shared "Related Contract" select: only contractual stages are shown and only signed contracts are selectable. */
export function RelatedContractBoundSelectField(props: RelatedContractBoundSelectFieldProps) {
  const { field, projectStages, readOnly, helperText = "Only signed contracts can be selected." } = props;
  return (
    <BoundSelectField
      label="Related Contract"
      field={field}
      options={projectStages.filter((s) => isContractualStage(s.stage.code))}
      getOptionLabel={({ stage }) => stage.name}
      getOptionValue={({ id }) => id}
      readOnly={readOnly}
      disabledOptions={projectStages.filter((ps) => !ps.hasSignedContract).map((ps) => ps.id)}
      helperText={helperText}
    />
  );
}
